<template>
  <div class="black-data">
    <div class="black-item black-num">
      <p>{{ numObj.blockHeight }}</p>
      <p>区块高度</p>
    </div>
    <div class="black-item contract-num">
      <p>{{ numObj.transactionNum }}</p>
      <p>累计交易数</p>
    </div>
    <div class="black-item transaction-num">
      <p>{{ numObj.contractNum }}</p>
      <p>累计合约数</p>
    </div>
    <div class="black-item organization-num">
      <p>{{ numObj.orgNum }}</p>
      <p>组织数</p>
    </div>
    <div class="black-item node-num">
      <p>{{ numObj.nodeNum }}</p>
      <p>节点数</p>
    </div>
  </div>
</template>

<script>
let echarts = require('echarts')
import { mapState, mapActions } from 'vuex'
export default {
  name: 'TxnLine',
  data() {
    return {
      chart: null,
      intervalId: null,
      numObj: {}
    }
  },
  computed: {},
  watch: {
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getData()
    }
  },
  mounted() {
    this.getData()
    this.intervalId = setInterval(() => {
      this.getData()
    }, 10000)
    window.addEventListener('resize', this.resize, false)
  },
  destroyed() {
    // 清除定时器和图表实例
    clearInterval(this.intervalId)
    this.chart.dispose()
  },
  methods: {
    getData() {
      let cid = this.$store.state.home.chainCid
      if (cid) {
        this.$apis.home.getOverview({ cid }).then(res => {
          if (res.data) {
            this.numObj = res.data
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/compatible/index.scss';

.black-data {
  .black-num {
    background-image: url('../../../assets/images/char/blockHeight.png');
    background-size: 100% 100%;
  }

  .contract-num {
    background-image: url('../../../assets/images/char/contractNum.png');
    background-size: 100% 100%;
  }

  .transaction-num {
    background-image: url('../../../assets/images/char/transactionNum.png');
    background-size: 100% 100%;
  }

  .organization-num {
    background-image: url('../../../assets/images/char/organizationNum.png');
    background-size: 100% 100%;
  }

  .node-num {
    background-image: url('../../../assets/images/char/nodeNum.png');
    background-size: 100% 100%;
  }
}
</style>
